import { render, staticRenderFns } from "./WelfareIcons.vue?vue&type=template&id=13d45d90&scoped=true"
import script from "./WelfareIcons.vue?vue&type=script&lang=js"
export * from "./WelfareIcons.vue?vue&type=script&lang=js"
import style0 from "./WelfareIcons.vue?vue&type=style&index=0&id=13d45d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d45d90",
  null
  
)

export default component.exports